import * as React from 'react';

interface NotionIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function NotionIcon({ size = 16, className, ...props }: NotionIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      {...props}
    >
      <path d="M6.017 4.313l55.333-4.087c6.797-.583 8.543-.19 12.817 2.917l17.663 12.443c2.913 2.14 3.883 2.723 3.883 5.053v68.243c0 4.277-1.553 6.807-6.99 7.193L24.467 99.967c-4.08.193-6.023-.39-8.16-3.113L3.3 79.94c-2.333-3.113-3.3-5.443-3.3-8.167V11.113c0-3.497 1.553-6.413 6.017-6.8z" />
      <path
        d="M61.35 0.227l-55.333 4.087C1.553 4.7 0 7.617 0 11.113v60.66c0 2.723.967 5.053 3.3 8.167l13.007 16.913c2.137 2.723 4.08 3.307 8.16 3.113l64.257-3.89c5.433-.387 6.99-2.917 6.99-7.193V20.64c0-2.21-.81-2.867-3.3-4.803l-17.663-12.44C71.247 1.033 68.147.05 61.35.227zM26.333 11.113l47.887-3.157c1.74-.143 2.053-.003 3.037.727l11.883 8.5c.377.287.467.527.467.857 0 .363-.12.69-.68.733L37.767 22.32c-1.697.143-2.48-.173-3.143-.833l-8.683-7.44c-.61-.53-.86-.907-.277-.92l.67-.013zm-5.61 78.557V26.92c0-1.18.363-1.717 1.47-1.797l60.067-3.54c1.04-.067 1.46.46 1.46 1.617v61.917c0 1.18-.183 2.177-1.84 2.293L27.15 91c-1.24.077-1.827-.34-1.827-1.33zm56.003-60.53c.17.757 0 1.513-.76 1.6l-2.903.557v45.833c-2.52 1.33-4.84 2.1-6.77 2.1-3.13 0-3.97-.987-6.327-3.97l-19.38-30.47v29.47l6.01 1.353s0 1.513-2.103 1.513l-5.81.35c-.17-.343 0-1.17.587-1.323l1.53-.407V37.313l-2.1-.177c-.17-.757.233-1.843 1.3-1.93l6.23-.41 20.14 30.81V37.583l-5.043-.557c-.17-.897.48-1.553 1.267-1.617l6.127-.397z"
        fill="white"
      />
    </svg>
  );
}

export default NotionIcon;
